<template>
  <div class="mt-5">
    <div class="text-center mt-5"><base-section-title>#{{ $t('blog_page.title') }}s</base-section-title></div>
    <blog-item
      v-for="blog in blogs"
      :key="blog.title"
      :link="blog.link"
      :title="blog.title"
      :description="blog.description"
      :publishDate="blog.publishDate"
      :tags="blog.tags"
    ></blog-item>
  </div>
</template>

<script>
import BaseSectionTitle from '../../base/BaseSectionTitle'
import BlogItem from '../../base/blog/BlogItem'
export default {
  name: 'BlogSection',
  components: { BaseSectionTitle, BlogItem },
  data () {
    return {
      blogs: [
        {
          title: 'Do Word Embedding Models Capture Stereotypes in Language?',
          description: 'Exploring Bias in NLP: How Word Embedding Models Mirror Human Stereotypes and How It\'s Measured',
          publishDate: '2022-10-27',
          tags: ['Word Embeddings', 'Word2Vec', 'Bias', 'Natural Language Processing', 'Stereotypes'],
          link: 'https://medium.com/@idriss-oulahbib/do-word-embeddings-models-captures-sterotypes-within-the-language-6c785f172747'
        }
      ]
    }
  }
}
</script>

<style scoped>
.min-h-70vh {
  min-height: 70vh;
}
</style>
